import { render, staticRenderFns } from "./catalog-unit.vue?vue&type=template&id=60202842&scoped=true&"
import script from "./catalog-unit.vue?vue&type=script&lang=tsx&"
export * from "./catalog-unit.vue?vue&type=script&lang=tsx&"
import style0 from "./catalog-unit.vue?vue&type=style&index=0&id=60202842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60202842",
  null
  
)

export default component.exports